import { render } from "./Loading.vue?vue&type=template&id=4d9c871b&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=4d9c871b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9c871b"]])

export default __exports__